import React, { useState } from 'react';
import { SearchIcon, DownloadIcon, XIcon } from 'lucide-react';
export function TransactionReport() {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [senderBank, setSenderBank] = useState('');
  const [receiverBank, setReceiverBank] = useState('');
  const [senderAccount, setSenderAccount] = useState('');
  const [receiverAccount, setReceiverAccount] = useState('');
  const [status, setStatus] = useState<'all' | 'success' | 'failed'>('all');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const banks = [{
    code: '',
    name: 'Select Bank'
  }, {
    code: 'AMHRETAA',
    name: 'Amhara Bank S.C.'
  }, {
    code: 'AWINETAA',
    name: 'Awash Bank S.C.'
  }, {
    code: 'CBETETAA',
    name: 'Commercial Bank of Ethiopia (CBE)'
  }, {
    code: 'BUNAETAA',
    name: 'Bunna International Bank S.C.'
  }, {
    code: 'DASHETAA',
    name: 'Dashen Bank S.C.'
  }, {
    code: 'CBORETAA',
    name: 'Cooperative Bank of Oromia S.C. (COOP)'
  }, {
    code: 'ZEMEETAA',
    name: 'Zemen Bank S.C.'
  }, {
    code: 'NIBIETAA',
    name: 'NIB International Bank S.C. (NIB)'
  }, {
    code: 'HIJRETAA',
    name: 'Hibret Bank S.C.'
  }, {
    code: 'TSCPETAA',
    name: 'Tsehay Bank S.C.'
  }, {
    code: 'WEGAETAA',
    name: 'Wegagen Bank S.C.'
  }, {
    code: 'ABAYETAA',
    name: 'Abay Bank S.C.'
  }];
  // Sample data - in a real app this would come from an API
  const sampleTransactions = [{
    id: 1,
    dateTime: '2023-05-10 14:30:22',
    senderBankBIC: 'AMHRETAA',
    senderBankName: 'Amhara Bank S.C.',
    senderAccount: '1000123456789',
    receiverBankBIC: 'CBETETAA',
    receiverBankName: 'Commercial Bank of Ethiopia (CBE)',
    receiverAccount: '2000987654321',
    amount: 5000,
    purposeCode: 'P2P',
    status: 'Success',
    failureReason: '',
    narration: 'Payment for services'
  }, {
    id: 2,
    dateTime: '2023-05-09 10:28:15',
    senderBankBIC: 'AWINETAA',
    senderBankName: 'Awash Bank S.C.',
    senderAccount: '1000223456789',
    receiverBankBIC: 'DASHETAA',
    receiverBankName: 'Dashen Bank S.C.',
    receiverAccount: '2000887654321',
    amount: 3500,
    purposeCode: 'BILL',
    status: 'Failed',
    failureReason: 'Insufficient funds',
    narration: 'Utility payment'
  }, {
    id: 3,
    dateTime: '2023-05-08 16:25:47',
    senderBankBIC: 'BUNAETAA',
    senderBankName: 'Bunna International Bank S.C.',
    senderAccount: '1000323456789',
    receiverBankBIC: 'ZEMEETAA',
    receiverBankName: 'Zemen Bank S.C.',
    receiverAccount: '2000787654321',
    amount: 2800,
    purposeCode: 'P2P',
    status: 'Success',
    failureReason: '',
    narration: 'Loan repayment'
  }, {
    id: 4,
    dateTime: '2023-05-07 09:15:33',
    senderBankBIC: 'HIJRETAA',
    senderBankName: 'Hibret Bank S.C.',
    senderAccount: '1000423456789',
    receiverBankBIC: 'WEGAETAA',
    receiverBankName: 'Wegagen Bank S.C.',
    receiverAccount: '2000687654321',
    amount: 7500,
    purposeCode: 'TRANSFER',
    status: 'Success',
    failureReason: '',
    narration: 'Fund transfer'
  }, {
    id: 5,
    dateTime: '2023-05-06 13:42:19',
    senderBankBIC: 'NIBIETAA',
    senderBankName: 'NIB International Bank S.C. (NIB)',
    senderAccount: '1000523456789',
    receiverBankBIC: 'ABAYETAA',
    receiverBankName: 'Abay Bank S.C.',
    receiverAccount: '2000587654321',
    amount: 12000,
    purposeCode: 'SALARY',
    status: 'Success',
    failureReason: '',
    narration: 'Salary payment'
  }];
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Validate date range (in a real app, you'd check server-side too)
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      const diffTime = Math.abs(to.getTime() - from.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 90) {
        alert('Date range cannot exceed 90 days');
        setIsLoading(false);
        return;
      }
      if (from > to) {
        alert('From date must be before To date');
        setIsLoading(false);
        return;
      }
    }
    // Simulate API delay
    setTimeout(() => {
      // Filter sample data based on search criteria
      let results = [...sampleTransactions];
      if (senderBank) {
        results = results.filter(t => t.senderBankBIC === senderBank);
      }
      if (receiverBank) {
        results = results.filter(t => t.receiverBankBIC === receiverBank);
      }
      if (senderAccount) {
        results = results.filter(t => t.senderAccount.includes(senderAccount));
      }
      if (receiverAccount) {
        results = results.filter(t => t.receiverAccount.includes(receiverAccount));
      }
      if (status !== 'all') {
        results = results.filter(t => status === 'success' && t.status === 'Success' || status === 'failed' && t.status === 'Failed');
      }
      setSearchResults(results);
      setHasSearched(true);
      setIsLoading(false);
    }, 800);
  };
  const handleRowClick = (transaction: any) => {
    setSelectedTransaction(transaction);
    setShowDetails(true);
  };
  const handleReset = () => {
    setFromDate('');
    setToDate('');
    setSenderBank('');
    setReceiverBank('');
    setSenderAccount('');
    setReceiverAccount('');
    setStatus('all');
    setSearchResults([]);
    setHasSearched(false);
  };
  const handleExport = (format: 'csv' | 'pdf') => {
    // In a real app, you would implement the actual export functionality
    alert(`Exporting as ${format.toUpperCase()}...`);
  };
  return <div className="space-y-6" data-id="element-882">
      <h1 className="text-2xl font-bold text-[#1A1F36]" data-id="element-883">Transaction Report</h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6" data-id="element-884">
        <form onSubmit={handleSearch} className="space-y-6" data-id="element-885">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-886">
            <div className="space-y-2" data-id="element-887">
              <label htmlFor="fromDate" className="block text-sm font-medium text-gray-700" data-id="element-888">
                From Date
              </label>
              <input id="fromDate" type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" required data-id="element-889" />
            </div>
            <div className="space-y-2" data-id="element-890">
              <label htmlFor="toDate" className="block text-sm font-medium text-gray-700" data-id="element-891">
                To Date
              </label>
              <input id="toDate" type="date" value={toDate} onChange={e => setToDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" required data-id="element-892" />
            </div>
            <div className="space-y-2" data-id="element-893">
              <label htmlFor="senderBank" className="block text-sm font-medium text-gray-700" data-id="element-894">
                Sender Bank
              </label>
              <select id="senderBank" value={senderBank} onChange={e => setSenderBank(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" data-id="element-895">
                {banks.map(bank => <option key={bank.code} value={bank.code} data-id="element-896">
                    {bank.name}
                  </option>)}
              </select>
            </div>
            <div className="space-y-2" data-id="element-897">
              <label htmlFor="receiverBank" className="block text-sm font-medium text-gray-700" data-id="element-898">
                Receiver Bank
              </label>
              <select id="receiverBank" value={receiverBank} onChange={e => setReceiverBank(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" data-id="element-899">
                {banks.map(bank => <option key={bank.code} value={bank.code} data-id="element-900">
                    {bank.name}
                  </option>)}
              </select>
            </div>
            <div className="space-y-2" data-id="element-901">
              <label htmlFor="senderAccount" className="block text-sm font-medium text-gray-700" data-id="element-902">
                Sender Account
              </label>
              <input id="senderAccount" type="text" value={senderAccount} onChange={e => setSenderAccount(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter sender account" data-id="element-903" />
            </div>
            <div className="space-y-2" data-id="element-904">
              <label htmlFor="receiverAccount" className="block text-sm font-medium text-gray-700" data-id="element-905">
                Receiver Account
              </label>
              <input id="receiverAccount" type="text" value={receiverAccount} onChange={e => setReceiverAccount(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:border-transparent" placeholder="Enter receiver account" data-id="element-906" />
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-907">
            <label className="text-sm font-medium text-gray-700 mr-3" data-id="element-908">
              Status:
            </label>
            <div className="flex items-center gap-2" data-id="element-909">
              <button type="button" onClick={() => setStatus('all')} className={`px-3 py-1 text-xs rounded-full ${status === 'all' ? 'bg-gray-200 text-gray-800' : 'bg-white border border-gray-300 text-gray-700'}`} data-id="element-910">
                All
              </button>
              <button type="button" onClick={() => setStatus('success')} className={`px-3 py-1 text-xs rounded-full ${status === 'success' ? 'bg-green-100 text-green-800' : 'bg-white border border-gray-300 text-gray-700'}`} data-id="element-911">
                Success
              </button>
              <button type="button" onClick={() => setStatus('failed')} className={`px-3 py-1 text-xs rounded-full ${status === 'failed' ? 'bg-red-100 text-red-800' : 'bg-white border border-gray-300 text-gray-700'}`} data-id="element-912">
                Failed
              </button>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-913">
            <button type="submit" disabled={isLoading} className="px-4 py-2 bg-[#F58220] text-white rounded-md font-medium hover:bg-[#e07619] focus:outline-none focus:ring-2 focus:ring-[#F58220] focus:ring-opacity-50 flex items-center" data-id="element-914">
              {isLoading ? <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-915">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-916"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-917"></path>
                  </svg>
                  Generating...
                </> : <>
                  <SearchIcon size={16} className="inline mr-2" data-id="element-918" />
                  Generate Report
                </>}
            </button>
            <button type="button" onClick={handleReset} className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50" data-id="element-919">
              Reset
            </button>
          </div>
        </form>
      </div>
      {hasSearched && <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden" data-id="element-920">
          <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-921">
            <h3 className="font-medium text-[#1A1F36]" data-id="element-922">Report Results</h3>
            {searchResults.length > 0 && <div className="flex items-center gap-3" data-id="element-923">
                <button onClick={() => handleExport('csv')} className="flex items-center bg-white border border-gray-300 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-924">
                  <DownloadIcon size={16} className="mr-2" data-id="element-925" />
                  Export CSV
                </button>
                <button onClick={() => handleExport('pdf')} className="flex items-center bg-white border border-gray-300 rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-926">
                  <DownloadIcon size={16} className="mr-2" data-id="element-927" />
                  Export PDF
                </button>
              </div>}
          </div>
          {searchResults.length === 0 ? <div className="p-8 text-center" data-id="element-928">
              <p className="text-gray-500" data-id="element-929">
                No transactions found matching your search criteria.
              </p>
            </div> : <div className="overflow-x-auto" data-id="element-930">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-931">
                <thead className="bg-gray-50" data-id="element-932">
                  <tr data-id="element-933">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-934">
                      Date Time
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-935">
                      Sender Bank
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-936">
                      Sender Account
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-937">
                      Receiver Bank
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-938">
                      Receiver Account
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-939">
                      Amount
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-940">
                      Purpose
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-941">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-942">
                  {searchResults.map(transaction => <tr key={transaction.id} onClick={() => handleRowClick(transaction)} className={`cursor-pointer hover:bg-gray-50 ${transaction.status === 'Failed' ? 'bg-red-50' : ''}`} data-id="element-943">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-944">
                        {transaction.dateTime}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-945">
                        {transaction.senderBankBIC}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-946">
                        {transaction.senderAccount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-947">
                        {transaction.receiverBankBIC}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-948">
                        {transaction.receiverAccount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-949">
                        ETB {transaction.amount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-950">
                        {transaction.purposeCode}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-951">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${transaction.status === 'Success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-952">
                          {transaction.status}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>}
        </div>}
      {showDetails && selectedTransaction && <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-10" data-id="element-953">
          <div className="bg-white w-full max-w-md h-full overflow-auto" data-id="element-954">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-955">
              <h3 className="font-medium text-[#1A1F36]" data-id="element-956">
                Transaction Details
              </h3>
              <button onClick={() => setShowDetails(false)} className="text-gray-500 hover:text-gray-700" data-id="element-957">
                <XIcon size={20} data-id="element-958" />
              </button>
            </div>
            <div className="p-4 space-y-4" data-id="element-959">
              <div data-id="element-960">
                <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-961">
                  Status
                </h4>
                <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${selectedTransaction.status === 'Success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-962">
                  {selectedTransaction.status}
                </span>
                {selectedTransaction.failureReason && <p className="mt-1 text-sm text-red-600" data-id="element-963">
                    {selectedTransaction.failureReason}
                  </p>}
              </div>
              <div data-id="element-964">
                <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-965">
                  Date & Time
                </h4>
                <p className="text-sm text-gray-900" data-id="element-966">
                  {selectedTransaction.dateTime}
                </p>
              </div>
              <div data-id="element-967">
                <h4 className="text-sm font-medium text-gray-500 mb-1" data-id="element-968">
                  Amount
                </h4>
                <p className="text-lg font-semibold text-[#1A1F36]" data-id="element-969">
                  ETB {selectedTransaction.amount.toLocaleString()}
                </p>
              </div>
              <div className="pt-2 border-t border-gray-200" data-id="element-970">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-971">
                  Sender Details
                </h4>
                <div className="space-y-2" data-id="element-972">
                  <div data-id="element-973">
                    <p className="text-xs text-gray-500" data-id="element-974">Bank BIC</p>
                    <p className="text-sm text-gray-900" data-id="element-975">
                      {selectedTransaction.senderBankBIC}
                    </p>
                  </div>
                  <div data-id="element-976">
                    <p className="text-xs text-gray-500" data-id="element-977">Bank Name</p>
                    <p className="text-sm text-gray-900" data-id="element-978">
                      {selectedTransaction.senderBankName}
                    </p>
                  </div>
                  <div data-id="element-979">
                    <p className="text-xs text-gray-500" data-id="element-980">Account</p>
                    <p className="text-sm text-gray-900" data-id="element-981">
                      {selectedTransaction.senderAccount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-2 border-t border-gray-200" data-id="element-982">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-983">
                  Receiver Details
                </h4>
                <div className="space-y-2" data-id="element-984">
                  <div data-id="element-985">
                    <p className="text-xs text-gray-500" data-id="element-986">Bank BIC</p>
                    <p className="text-sm text-gray-900" data-id="element-987">
                      {selectedTransaction.receiverBankBIC}
                    </p>
                  </div>
                  <div data-id="element-988">
                    <p className="text-xs text-gray-500" data-id="element-989">Bank Name</p>
                    <p className="text-sm text-gray-900" data-id="element-990">
                      {selectedTransaction.receiverBankName}
                    </p>
                  </div>
                  <div data-id="element-991">
                    <p className="text-xs text-gray-500" data-id="element-992">Account</p>
                    <p className="text-sm text-gray-900" data-id="element-993">
                      {selectedTransaction.receiverAccount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-2 border-t border-gray-200" data-id="element-994">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-995">
                  Additional Information
                </h4>
                <div className="space-y-2" data-id="element-996">
                  <div data-id="element-997">
                    <p className="text-xs text-gray-500" data-id="element-998">Purpose Code</p>
                    <p className="text-sm text-gray-900" data-id="element-999">
                      {selectedTransaction.purposeCode}
                    </p>
                  </div>
                  <div data-id="element-1000">
                    <p className="text-xs text-gray-500" data-id="element-1001">Narration</p>
                    <p className="text-sm text-gray-900" data-id="element-1002">
                      {selectedTransaction.narration}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}